/**
 * Tipos de documento del edificio (`buildingdocs.type`). Única fuente para el
 * admin (DocumentacionAdmin) y el residente (DocumentacionEdificio).
 * `value` es lo que se guarda en Firestore (y lo que filtra Habi por subcadena);
 * `key` es la clave de traducción (typeLabel.* / typeDesc.*).
 */
export const DOC_TYPES = [
  { value: "Seguros", key: "seguros" },
  { value: "BPS", key: "bps" },
  { value: "Intendencia", key: "intendencia" },
  { value: "Reglamento", key: "reglamento" },
  { value: "Actas de asambleas", key: "actas" },
  { value: "Manuales", key: "manuales" },
  { value: "Otros", key: "otros" },
];

// Tipos viejos → tipo actual. "Factura" no tiene equivalente: se conserva
// como tipo legacy (se sigue mostrando, pero ya no se ofrece al cargar).
const LEGACY_MAP = { Otro: "Otros", Acta: "Actas de asambleas" };
const LEGACY_KEYS = { Factura: "factura" };

export const DEFAULT_DOC_TYPE = "Otros";

export function normalizeDocType(type) {
  if (!type) return DEFAULT_DOC_TYPE;
  return LEGACY_MAP[type] || type;
}

/** Clave de traducción del tipo; tipos desconocidos caen en "otros". */
export function docTypeKey(type) {
  const t = normalizeDocType(type);
  const found = DOC_TYPES.find((d) => d.value === t);
  return found ? found.key : LEGACY_KEYS[t] || "otros";
}

/** Opciones para el select: si el doc tiene un tipo legacy, se agrega para no perderlo al editar. */
export function docTypeOptions(currentType) {
  const values = DOC_TYPES.map((d) => d.value);
  const cur = normalizeDocType(currentType);
  return values.includes(cur) ? values : [...values, cur];
}
